import { DatePipe } from "@angular/common";
import { Injectable } from "@angular/core";
import { ApplicationStageLabel, HorizontalListData, HorizontalListFactory, HorizontalListOptionType } from "common";
import { ApplicationProfileComponentData } from "../application-profile/application-profile.component";

@Injectable()
export class ApplicationStatusWidgetAdapter {
  constructor(
    private readonly datePipe: DatePipe,
  ) { }

  adaptListData = (data: ApplicationProfileComponentData): HorizontalListData[] => {
    return [
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Stage',
        displayedValue: ApplicationStageLabel.get(data?.application?.stage),
      }),
      HorizontalListFactory.createKeyValueCustomValueTemplateItem({
        title: 'Salesforce status',
        customTemplateName: "salesforceStatusValue",
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Type',
        displayedValue: data?.application?.type,
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Created on',
        displayedValue: this.datePipe.transform(data?.application?.createdOn) || '-',
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Created by',
        displayedValue: data?.application?.createdBy,
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Updated on',
        displayedValue: this.datePipe.transform(data?.application?.updatedOn) || '-',
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Updated by',
        displayedValue: data?.application?.updatedBy,
      }),
      HorizontalListFactory.createKeyValueCustomItem({
        titleData: {
          optionType: HorizontalListOptionType.ExternalLink,
          displayedValue: "Offer page link",
          externalLink: data?.application?.offerPageUrl
        },
        valueData: {
          optionType: HorizontalListOptionType.CustomTemplate,
          customTemplateName: "copyOfferLinkAction"
        }
      }),
    ]
  }
}